export enum ButtonVariant {
  Primary = 'primary',
  Secondary = 'secondary',
  Grey = 'grey',
  Gradient = 'gradient',
  Danger = 'danger',
  Outline = 'outline',
  OutlineSecondary = 'outlineSecondary',
  OutlineDanger = 'outlineDanger',
  Ghost = 'ghost',
  Text = 'text',
  TextSecondary = 'textSecondary',
}

export enum ButtonSize {
  Content = 'content',
  Compact = 'compact',
  ExtraSmall = 'extraSmall',
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  ExtraLarge = 'extraLarge',
  FullWidth = 'full',
}

export enum ButtonIconSize {
  Medium = 'iconMedium',
  Large = 'iconLarge',
}
